import SelectInput from "@builder/components/general/ConditionSelectInput";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { getCFDS } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useEffect, useState } from "react";
import { ActionType } from "@common/build/types";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useTranslation } from "react-i18next";

const UpdateCFD = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const pages = useAppSelector(getCFDS);
    const dispatch = useAppDispatch();
    const [selectedPage, setSelectedPage] = useState<string>(actionStep?.action?.target || "");
    const { t } = useTranslation();

    const pagesWithDefault = [{ id: "-1", name: "Previous Page" }, ...pages];
    const pageNames = pagesWithDefault.map(page => page.name);

    const pageIdToNameMap = pagesWithDefault.reduce((acc, page) => {
        acc[page.id] = page.name;
        return acc;
    }, {} as Record<string, string>);

    const handlePageSelection = (name: string) => {
        const selectedPageId = Object.keys(pageIdToNameMap).find(key => pageIdToNameMap[key] === name);
        setSelectedPage(selectedPageId || "");
    };

    useEffect(() => {
        if (selectedPage) {
            const action = { type: ActionType.NAVIGATE_TO_PAGE_CFD, target: selectedPage };
            const updatedStep = {
                ...actionStep,
                title: `${t("popup.actionBuilder.Go to page")}: ${pageIdToNameMap[selectedPage]}`,
                noTranslate: true
            };
            updatedStep.action = { ...action };
            if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
                dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
            }
        }
    }, [selectedPage, actionStep, dispatch, id, t, pageIdToNameMap]);

    return (
        <SelectInput
            title="Which page or popup do you want to update to?"
            layout="column"
            value={pageIdToNameMap[selectedPage]}
            callback={handlePageSelection}
            options={pageNames}
            placeholder="Select page"
        />
    );
};

export default UpdateCFD;
